<div class="tile-padding-first">
  <div class="flex-container">
    <form [formGroup]="frmClientUser" novalidate>
      <div class="flex-row">
        <div class="flex-column" id="multifactor">
          <!--<label>Multi Factor Authentication for all users</label>-->
          <label class="field__checkbox"><span>Multi Factor Authentication</span><input type="checkbox" id="mfaEnabled" formControlName="mfaEnabled" [disabled]="disableMfa" (change)="updateMfa({checked: $event.target.checked})" /></label>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column">
          <label class="field__label">First Name</label>
          <input class="field__control" id="firstName" required formControlName="firstName">
          @if (frmClientUser.controls.firstName.invalid && frmClientUser.controls.firstName.touched) {
            <span class="field__error">First name required</span>
          }
        </div>
        <div class="flex-column">
          <label class="field__label">Last Name</label>
          <input class="field__control body-content" formControlName="lastName" required />
          @if (frmClientUser.controls.lastName.invalid && frmClientUser.controls.lastName.touched) {
            <span class="field__error">Last name required</span>
          }
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column">
          <label class="field__label">Mobile</label>
          <input class="field__control body-content" [pattern]="mobNumberPattern" formControlName="mobileNumber" [required]="frmClientUser.value.mfaEnabled" />
          @if (frmClientUser.controls.mobileNumber.invalid && frmClientUser.controls.mobileNumber.touched) {
            <span class="field__error">Enter a valid mobile number</span>
          }
        </div>
        <div class="flex-column">
          <label class="field__label">Email</label>
          <input class="field__control body-content" formControlName="email" required />
          @if (frmClientUser.controls.email.invalid && frmClientUser.controls.email.touched) {
            <span class="field__error">Email required</span>
          }
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column" id="stopAutomaticReportsContainer">
          <label class="field__checkbox"><span>Stop automatic report emails</span><input type="checkbox" id="stopAutomaticReports" formControlName="stopAutomaticReports" (change)="updateAutomaticReports({checked: $event.target.checked})" /></label>
        </div>
      </div>
      @if (showMfaTextField) {
        <div class="flex-row">
          <div class="flex-column mfa-code">
            <label class="field__label" for="mfaCode"> Authentication Code </label>
            <input class="field__control body-content" formControlName="mfaCode" numberOnly="true" />
            @if (frmClientUser.controls.mfaCode.invalid && frmClientUser.controls.mfaCode.touched) {
              <span class="field__error">Authentication Code is Required!</span>
            }
          </div>
          <div class="flex-column div-content-start">
            <div>
              <button class="btn btn-primary" (click)="generateMfa('resend')">Resend</button>
            </div>
          </div>
        </div>
      }
      <div class="div-flex-buttons">
        @if (!showContinueButton) {
          <div><button class="btn btn-primary" id="SaveUser" name="SaveUser" value="SaveUser" (click)="submitUser()">Update Account</button></div>
        }
        @if (showContinueButton) {
          <div><button class="btn btn-primary" (click)="generateMfa('activation')">Update User</button></div>
        }
      </div>
    </form>
  </div>
</div>